import React from 'react';
import { Field } from 'redux-form';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'


const renderSelectField = ({input, label, placeholder,multiple, className,MenuProps, style, children, error = false, required = false, readOnly = false}) => (
    <FormControl style={{marginTop: 8}}>
        <InputLabel>{label}</InputLabel>
        <Select
            {...input}
            multiple={multiple}
            value={input.value || []}
            renderValue={selected => selected.join(', ')}
            className={className}
            required={required}
            MenuProps={MenuProps}
            onChange={(e) => input.onChange(e.target.value)}
            style={style}
        >
            {children}
        </Select>
    </FormControl>
)
export default (obj) => {
    return <Field component={renderSelectField} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/multiSelect.js